import { render, staticRenderFns } from "./account-register.vue?vue&type=template&id=e64031d6&scoped=true"
import script from "./account-register.vue?vue&type=script&lang=js"
export * from "./account-register.vue?vue&type=script&lang=js"
import style0 from "./account-register.vue?vue&type=style&index=0&id=e64031d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64031d6",
  null
  
)

export default component.exports